import { db, auth, functions } from '../config/firebase-config';
import { collection, getDocs, getDoc, addDoc, updateDoc, doc, setDoc, deleteDoc, query, where, orderBy, serverTimestamp, startAfter, limit } from 'firebase/firestore';
import { httpsCallable } from 'firebase/functions';

import { setAlert  } from './alertActions';

import {  
    GET_ADS,
    SET_ADS,
    SET_LAST_ADS,
    AD_ERROR,
    CLEAR_ADS,
    ADS_LOADING,
    GET_AD
} from './types';

// Reference to the "ads" collection in Firestore
const adsCollectionRef = collection(db, "ads");
// Reference to the "posts" collection in Firestore
const postsCollectionRef = collection(db, "posts");

// Declare cloud function for use in this file
const activateAd_updateFunds = httpsCallable(functions, 'activateAd');

// Get Current user ads 
export const getUserAds = (lastPageDoc) => async dispatch => {

    if(!lastPageDoc) dispatch(setAdsLoading());

    try {
            
        dispatch({  
            type: SET_ADS,
            payload: []
        });  

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action to handle the ad error
        dispatch({
            type: AD_ERROR,
            payload: []
        })
    }
}

// Get Ads by User ID
export const getAdsByUserID = (userID) => async dispatch => {

    dispatch(clearAds());

    try {

        // Create a query to retrieve orders where the user ID matches the provided ID, ordered by creation date in descending order
        const q = query(adsCollectionRef, where("user._id", "==", userID), orderBy('createdAt', 'desc'));

        // Execute the query and retrieve the query snapshot
        const querySnapshot = await getDocs(q);

        // Map through the document snapshots in the query snapshot and extract the data and ID for each order
        const userAds = querySnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // Dispatch an action of type GET_ORDERS with the user orders as the payload
        dispatch({
            type: GET_ADS,
            payload: userAds
        });
    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action of type GET_POSTS with an empty array as the payload in case of an error
        dispatch({
            type: GET_ADS,
            payload: []
        })
    }
};

// Get Ad data and convert into posts for feed
export const getAdsTurnToPosts = (lastPageDoc) => async dispatch => {

    if(!lastPageDoc) dispatch(setAdsLoading());

    try {
        const final_ads_list = await getAdsTurnToPosts_Helper(lastPageDoc);


        // Dispatch an action to update the state with the retrieved ads
        if(final_ads_list.length < 2 && lastPageDoc) {
            dispatch({
                type: SET_LAST_ADS,
                payload: final_ads_list
            });
        } else {
            dispatch({
                type: SET_ADS,
                payload: final_ads_list
            });
        }

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action to handle the ad error
        dispatch({
            type: AD_ERROR,
            payload: []
        })
    }
}

// Add to Noticiations
export const setAds = adData => async dispatch => {
    try {

        // Dispatch an action to update the state with the ad data
        dispatch({
            type: SET_ADS,
            payload: adData
        });

    } catch (err) {

        // Dispatch an action to handle the error case with an empty payload
        dispatch({
            type: SET_ADS,
            payload: []
        })
    }
};

// Create New Ad
export const createAd = ( 
    postId,
    formData,
    userData
) => async dispatch => {

    const {
        cta_type,
        cta_url,
        cta_label,
        run_until_pause,
        duration_days, 
        amount_budgeted
    } = formData;

    try {

        // Create Ad

        // --- Prepare the fields for the new ad document

        const docFields = {};

        docFields.postId = postId;
        
        docFields.cta = {}
        
        docFields.cta.type = cta_type;
        docFields.cta.url = cta_url;
        docFields.cta.label = cta_label;

        docFields.targeting = {}
        
        docFields.targeting.locations = [];
        docFields.targeting.interests = [];
        docFields.targeting.school_years = [];

        docFields.budget = {}
        
        docFields.budget.duration_minutes = duration_days * 24 * 60;
        docFields.budget.amount_budgeted = amount_budgeted;
        docFields.budget.total_spent = 0;

        docFields.run_until_pause = run_until_pause;

        docFields.start_time = null;
        docFields.end_time_adjusted = null;
        docFields.paused_at = null;
        docFields.time_paused = 0;
        

        docFields.status = "checkout";
    
        docFields.date = Date.now();
        docFields.createdAt = serverTimestamp();
        docFields.lastModified = serverTimestamp();

        docFields.last_charged_at = null;

        docFields.payment_id = null;

        docFields.user = userData;

        // Add the new ad document to the ads collection
        const newDocRef = await addDoc(adsCollectionRef, docFields);
        const ad_id = newDocRef.id;

        dispatch(setAlert('Ad is being processed', 'okay'));

        console.log("AD CREATED SUCCESSFULLY");

        return ad_id;

        // window.location.href = `/post/${postId}`;

    } catch (err) {
        console.log('ERROR CREATING AD!!!');
        console.log(err);

        dispatch(setAlert('Something went wrong', 'danger'));

        // Handle the error if creating the ad fails
        //   dispatch({
        //     type: AD_ERROR,
        //     payload: { msg: err.response.statusText, status: err.response.status }
        //   });
    }
};

export const editAdTitle = (formData) => async dispatch => {
    const { title, adId } = formData;
    
    // Reference to the user document in the Firestore database
    const adDoc = doc(db, "ads", adId);

    // Try block to handle the update operation
    try {

        // Update DB
        await updateDoc(adDoc, {
            title
        })

        console.log('DONE UPDATING');

        // Dispatch a success alert indicating that the profile has been updated
        dispatch(setAlert('Saved changes!', 'success'));

    } catch (err) {
        console.log('ERRORS')
        console.log(err);
        
        if(err.response) {
            const errors = err.response.data.errors;

            // Dispatch alerts for each error received from the server
            if(errors) {
                errors.forEach(error => dispatch(setAlert(error.msg, 'danger')));
            }
        } else {

            // Display a generic error message if no specific error response is received
            setAlert('Something went wrong', 'danger')
        }
    }
}

// Ads loading
export const setAdsLoading = () => {
    return {
        type: ADS_LOADING
    }
}

// Remove all Ads
export const clearAds = () => dispatch => {

    // Dispatch an action to set loading state for ads
    dispatch(setAdsLoading());

    // Dispatch an action to clear all ads in the state
    dispatch({
        type: CLEAR_ADS
    });

}

// Get Ad By Post ID 
export const getAdsByPostId = (postId) => async dispatch => {

    dispatch(setAdsLoading());

    try {

        // Create a query to retrieve comments where the post_commented_on field matches the provided post ID, ordered by creation date in descending order
        const adQuery = query(adsCollectionRef, where("postId", "==", postId), orderBy('createdAt', 'desc'));
        
        // Execute the query and retrieve the query snapshot
        const querySnapshot = await getDocs(adQuery);
        
        // Map through the document snapshots in the query snapshot and extract the data and ID
        const postAds = querySnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));
            
        // Now postComments array contains all comments and comments of comments

        dispatch({
            type: GET_ADS,
            payload: postAds
        });

    } catch (err) {
        console.log('ERROR!!!')
        console.log(err)

        // Dispatch an action to handle the ad error
        dispatch({
            type: AD_ERROR,
            payload: []
        })
    }
}

// Get single Ad by id
export const getAdById = id => async dispatch => {
    dispatch(setAdsLoading());
    try {

        // Create a reference to the specified ad document in the "ads" collection
        const docRef = doc(db, 'ads', id)

        // Retrieve the document with the specified ID from the "ads" collection
        const adDoc = await getDoc(docRef);
  
        // Dispatch an action of type GET_AD with the ad data and ID as the payload
        if(adDoc.data()) {
            // Dispatch an action of type GET_AD with the ad data and ID as the payload
            dispatch({
                type: GET_AD,
                payload: {
                    ...adDoc.data(),
                    _id: id
                }
            });
        } else {
            dispatch({
                type: GET_AD,
                payload: null
            });

            dispatch(setAlert('Sorry, that ad has been deleted.', 'okay'));
        }
    } catch (err) {

        // Dispatch an action of type POST_ERROR with an error message and status code as the payload
        dispatch({
            type: AD_ERROR,
            payload: { msg: "something went wrong", status: 500 }
        });
        
        // Log the error to the console
        console.log(err);
    }
}

// Update Ad Status to Active
export const activateAd = (ad_obj, redirect) => async dispatch => {
    console.log("ACTIVATING AD");

    try {
        // Call cloud function
        const response = await activateAd_updateFunds(ad_obj);

        localStorage.setItem("trigger_alert", "actived_ad");
        
        if(redirect) {
            window.location.href = `/post/${ad_obj.postId}`;
        }

    } catch (err) {
        console.log('ERROR ACTIVATING AD!!!');
        console.log(err);

        dispatch(setAlert('Failed to activate ad', 'danger'));
        
        throw err;
    }
};

// Update Ad Status to Pause
export const pauseAd = (ad_obj) => async dispatch => {
    console.log("PAUSING AD");

    try {

        if (ad_obj === null) throw new Error("Ad doesn't exist");

        if (ad_obj.status !== "active") throw new Error("Only active ads can be paused");
        
        // Reference to the specific ad document
        const adDocRef = doc(db, 'ads', ad_obj._id);

        // Update the status to active
        await updateDoc(adDocRef, {
            status: "paused",
            paused_at: Date.now(), 
            lastModified: serverTimestamp()
        });

        dispatch(setAlert('Ad paused successfully', 'okay'));

        console.log("AD PAUSED SUCCESSFULLY");

    } catch (err) {
        console.log('ERROR PAUSING AD!!!');
        console.log(err);

        dispatch(setAlert('Failed to pause ad', 'danger'));
        
        throw err;
    }
};

// Update Ad Status to 'Active'
export const resumeAd = (ad_obj) => async dispatch => {
    console.log("RESUMING AD");

    try {
        // Get accurate data directly from DB
        const adRef = doc(db, "ads", ad_obj._id);
        const adSnap = await getDoc(adRef);

        if (!adSnap.exists()) throw new Error("Ad not found");
        const ad = adSnap.data();

        if (ad.status !== "paused") throw new Error("Only paused ads can be resumed");

        const pausedDuration = Date.now() - ad.paused_at;
        const time_paused = (ad.time_paused || 0) + pausedDuration;

        const end_time_adjusted = ad.end_time_adjusted + time_paused;

        // Update the status to active
        await updateDoc(adRef, {
            status: "active",
            paused_at: null, 
            time_paused,
            end_time_adjusted,
            lastModified: serverTimestamp()
        });

        dispatch(setAlert('Ad Resumed!', 'okay'));

        console.log("AD PAUSED SUCCESSFULLY");

    } catch (err) {
        console.log('ERROR PAUSING AD!!!');
        console.log(err);

        dispatch(setAlert('Failed to pause ad', 'danger'));
        
        throw err;
    }
};

// Update Ad Status to Stopped
export const stopAd = (ad_obj) => async dispatch => {
    console.log("STOPPING AD");

    try {

        const adRef = doc(db, "ads", ad_obj._id);
        const adSnap = await getDoc(adRef);

        if (!adSnap.exists()) throw new Error("Ad not found");
        const ad = adSnap.data();

        if (ad.status === "stopped") throw new Error("Ad is already stopped");

        await updateDoc(adRef, {
            status: "stopped",
            paused_at: null,
            lastModified: serverTimestamp()
        });

        dispatch(setAlert('Ad stopped.', 'okay'));

        console.log("AD STOPPED SUCCESSFULLY");

    } catch (err) {
        console.log('ERROR STOPPING AD!!!');
        console.log(err);

        dispatch(setAlert('Failed to stop ad', 'danger'));
        
        throw err;
    }
};

// Delete Chat
export const deleteAd = (ad) => async dispatch => {
    try {

        // Get a reference to the ad document
        const adRef = doc(db, 'ads', ad._id)

        // Delete the chat document
        await deleteDoc(adRef);

        // Redirect to the 'Post' page
        window.location.href = `/post/${ad.postId}`;
        
        // Set an alert to inform the user that the post was deleted
        // dispatch(setAlert('Ad Removed', 'okay'));
        
    } catch (err) {
        console.log('ERROR');
        console.log(err);

        // Dispatch an alert to notify that something went wrong
        dispatch(setAlert('Something went wrong', 'danger'));
    }
}

// --- Helper functions ----
export const getAdsTurnToPosts_Helper = async (lastPageDoc) => {

    console.log('Fetching ads as posts')

    try {
        let q;
        
        if(lastPageDoc) {
            // Create a query to fetch ads starting at the last visible document
            q = query(adsCollectionRef, where("status", "==", "active"), where("end_time_adjusted", ">", Date.now()), orderBy("end_time_adjusted", "asc"), orderBy('createdAt', 'desc'), startAfter(lastPageDoc || 0));
        } else {
            // Create a query to fetch ads
            q = query(adsCollectionRef, where("status", "==", "active"), where("end_time_adjusted", ">", Date.now()), orderBy("end_time_adjusted", "asc"), orderBy('createdAt', 'desc'));
        }

        // Execute the query and retrieve the query snapshot
        const querySnapshot = await getDocs(q);

        // Map the query snapshot to an array of ad objects with document ID
        const ads = querySnapshot.docs.map((doc) => ({...doc.data(), _id: doc.id}));

        // --- Convert the ads to post ---

        let final_ads_list = [];

        for(const ad of ads) {
            if(ad.postId === null || ad.postId === "") continue;

            // Create a reference to the specified post document in the "posts" collection
            const postRef = doc(db, 'posts', ad.postId);

            // Retrieve the document with the specified ID from the "posts" collection
            const postDoc = await getDoc(postRef);
        
            if(postDoc.data()) {
                final_ads_list.push({
                    ...postDoc.data(),
                    _id: ad.postId,
                    cta: ad.cta,
                    ad_id: ad._id,
                    isSponsored: true
                })
            }
        }

        // --- END: Convert the ads to post ---

        return final_ads_list;

    } catch (err) {
        console.log('ERROR GETTING ADS AS POSTS!!!')
        console.log(err)

        throw new Error('Failed to get ads as posts');
    }
}
